// Anonymous testimonial quotes — no names by studio policy.
// Each entry is { quote, attribution } only.
export const TESTIMONIAL_QUOTES = [
  {
    quote: 'Helped me understand what actually works for my body, lifestyle, and work image.',
    attribution: 'Founder, Bengaluru',
  },
  {
    quote: 'My wardrobe finally feels sharper, simpler, and more intentional.',
    attribution: 'Senior Professional, Mumbai',
  },
  {
    quote: 'The styling felt premium, practical, and very personal — not generic advice.',
    attribution: 'Entrepreneur, Chennai',
  },
];
